import { render, staticRenderFns } from "./PerformedSearches.vue?vue&type=template&id=b3cb6780&scoped=true&"
import script from "./PerformedSearches.vue?vue&type=script&lang=js&"
export * from "./PerformedSearches.vue?vue&type=script&lang=js&"
import style0 from "./PerformedSearches.vue?vue&type=style&index=0&id=b3cb6780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb6780",
  null
  
)

export default component.exports